import { toast } from 'react-toastify';
import { apiClient } from './client';
import { handleApiError } from './utils';

export const assignTaskToUser = async ({ resource, id, userId }) => {
    if (!resource) {
        toast.error('Atama işlemi için kaynak belirtilmelidir.');
        throw new Error('Resource is missing for task assignment.');
    }
    if (!id) {
        toast.error('Atama işlemi için kayıt ID gereklidir.');
        throw new Error('Id is missing for task assignment.');
    }
    if (!userId) {
        toast.error('Atama işlemi için kullanıcı ID gereklidir.');
        throw new Error('UserId is missing for task assignment.');
    }

    try {
        const response = await apiClient.put(`/${resource}/update-assignment/${id}`, { userId });
        return response.data;
    } catch (error) {
        handleApiError(error, 'İş atanırken bir hata oluştu.');
        throw error;
    }
};

export const resetTaskAssignment = async ({ resource, id }) => {
    if (!resource) {
        toast.error('Atama kaldırma işlemi için kaynak belirtilmelidir.');
        throw new Error('Resource is missing for task reset.');
    }
    if (!id) {
        toast.error('Atama kaldırma işlemi için kayıt ID gereklidir.');
        throw new Error('Id is missing for task reset.');
    }

    try {
        const response = await apiClient.post(`/${resource}/reset-task/${id}`);
        return response.data;
    } catch (error) {
        handleApiError(error, 'İş ataması kaldırılırken bir hata oluştu.');
        throw error;
    }
};

export const requestNewTask = async ({ apiEndpoint }) => {
    if (!apiEndpoint) {
        toast.error("Yeni iş talep etmek için API endpoint'i gereklidir.");
        throw new Error('API endpoint is missing for task request.');
    }

    try {
        const response = await apiClient.post(apiEndpoint);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Yeni iş talep edilirken bir hata oluştu.');
        throw error;
    }
};

export const assignToSelf = async ({ apiEndpoint, callFormId }) => {
    if (!apiEndpoint) {
        toast.error("Kendine atama işlemi için API endpoint'i gereklidir.");
        throw new Error('API endpoint is missing for assign to self request.');
    }

    if (!callFormId) {
        toast.error("Kendine atama işlemi için çağrı formu ID'si gereklidir.");
        throw new Error('Call form ID is missing for assign to self request.');
    }

    try {
        const response = await apiClient.put(`${apiEndpoint}/${callFormId}`);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Kendine atama işlemi sırasında hata oluştu.');
        throw error;
    }
};

export const releaseFromSelf = async ({ apiEndpoint, callFormId }) => {
    if (!apiEndpoint) {
        toast.error("Kendinden kaldırma işlemi için API endpoint'i gereklidir.");
        throw new Error('API endpoint is missing for release from self request.');
    }

    if (!callFormId) {
        toast.error("Kendinden kaldırma işlemi için çağrı formu ID'si gereklidir.");
        throw new Error('Call form ID is missing for release from self request.');
    }

    try {
        const response = await apiClient.put(`${apiEndpoint}/${callFormId}`);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Kendinden kaldırma işlemi sırasında hata oluştu.');
        throw error;
    }
};
